import { REPORT, REPORT_DETAIL } from "../../constants/urls";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: REPORT,
    lazy: () => import("./routes/ReportList"),
  },
  {
    path: REPORT_DETAIL,
    lazy: () => import("./routes/ReportDetail"),
  },
] as RouteObject[];
